export default __webpack_public_path__ + "4d8f2394da4aba015cb874923eec818f.png";